if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle?.addEventListener('toggle', this.onToggle.bind(this));
    }

    onToggle() {
      if (!this.mainDetailsToggle.open) return;
      document.body.classList.add('overflow-hidden');
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = this.querySelector('details[open]');
      if (openDetailsElement) {
        openDetailsElement.closest('details').removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.closeMenu();
        }
      });
    }

    closeMenu() {
      this.mainDetailsToggle.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}
